/* eslint-disable  @typescript-eslint/no-explicit-any */
import { initialColumns } from "./create-lead-capture-form-constant";
import { routes } from "../../../constants/routes";

export const onDragEnd = (
  source: any,
  destination: any,
  columns: any,
  setColumns: any,
) => {
  // Make sure we have a valid destination
  if (destination === undefined || destination === null) return null;

  // Make sure we're actually moving the item
  if (
    source.droppableId === destination.droppableId &&
    destination.index === source.index
  )
    return null;

  // Set start and end variables
  const start = columns[source.droppableId];
  const end = columns[destination.droppableId];

  // If start is the same as end, we're in the same column
  if (start === end) {
    // Move the item within the list
    // Start by making a new list without the dragged item
    const newList = start?.list?.filter(
      (_: any, idx: number) => idx !== source.index,
    );

    // Then insert the item at the right location
    newList?.splice(destination.index, 0, start.list[source.index]);

    // Then create a new copy of the column object
    const newCol = {
      id: start?.id,
      list: newList,
    };

    // Update the state
    setColumns((state: any) => ({ ...state, [newCol.id]: newCol }));
    return null;
  } else {
    // If start is different from end, we need to update multiple columns
    // Filter the start list like before
    const newStartList = start.list.filter(
      (_: any, idx: number) => idx !== source.index,
    );

    // Create a new start column
    const newStartCol = {
      id: start?.id,
      list: newStartList,
    };

    // Make a new end list array
    const newEndList = end?.list;

    // Insert the item into the end list
    newEndList.splice(destination.index, 0, start.list[source.index]);

    // Create a new end column
    const newEndCol = {
      id: end?.id,
      list: newEndList,
    };

    // Update the state
    setColumns((state: any) => ({
      ...state,
      [newStartCol.id]: newStartCol,
      [newEndCol.id]: newEndCol,
    }));
    return null;
  }
};

export const handleClose = (
  data: any,
  col: any,
  index: any,
  columns: any,
  setColumns: any,
) => {
  const newList = col?.list?.filter((_: any, idx: number) => idx !== index);
  const newListMain = [...(columns?.main?.list || []), data];
  const newCol = {
    id: "sub",
    list: newList,
  };
  const newColMain = {
    id: "main",
    list: newListMain.sort((a, b) => a?.id - b?.id),
  };

  setColumns((state: any) => ({
    ...state,
    ["sub"]: newCol,
    ["main"]: newColMain,
  }));
};

export const handleRequiredCheckBox = (
  data: any,
  col: any,
  columns: any,
  setColumns: any,
) => {
  const newList = col?.list?.map((item: any) => {
    if (item?.title === data?.title) {
      return {
        ...item,
        isRequired: !item?.isRequired,
      };
    }
    return item;
  });
  const newCol = {
    id: col?.id,
    list: newList,
  };
  setColumns((state: any) => ({
    ...state,
    [newCol.id]: newCol,
  }));
};

export const getLeadCapturePreviewBreadcrumbLink = (
  viewType: any,
  setIsShowCreateLeadSection: any,
  setIsPreview: any,
  setIsCreateLeadDragDrop: any,
  setColumns?: any,
  setIsViewMode?: any,
  setBreadcrumb?: any,
  formName?: string,
  setViewOpenForm?: any,
) => {
  if (viewType === "new") {
    return [
      {
        label: "Lead Capture",
        link: "/home/lead-management/lead-capture",
        handleClick: () => {
          setIsShowCreateLeadSection(false);
          setViewOpenForm?.(false);
          if(setColumns){
            setColumns(initialColumns);
          }
        }
      },
      {
        label: "Form List",
        link: routes.LEADCAPTUREFORM,
        handleClick: () => {
          setIsShowCreateLeadSection(false);
          setViewOpenForm?.(false);
          if(setColumns){
            setColumns(initialColumns);
          }
           
        },
      },
      { label: "Custom Lead Form", link: "#", handleClick: () => {} },
    ];
  }else if (viewType === "edit") {
    return [
      {
        label: "Lead Capture",
        link: "/home/lead-management/lead-capture",
        handleClick: () => {
          setIsShowCreateLeadSection(false);
          setViewOpenForm?.(false);
          if(setColumns){
            setColumns(initialColumns);
          }
        }
      },
      {
        label: "Form List",
        link: routes.LEADCAPTUREFORM,
        handleClick: () => {
          setIsShowCreateLeadSection(false);
          setViewOpenForm?.(false);
          if(setColumns){
            setColumns(initialColumns);
          }
           
        },
      },
      { label: formName, link: "#", handleClick: () => {} },
    ];
  }else if (viewType === "edit preview") {
    return [
      {
            label: "Lead Capture",
            link: "/home/lead-management/lead-capture",
            handleClick: () => {
              setIsShowCreateLeadSection(false);
              setViewOpenForm?.(false);
              if(setColumns){
                setColumns(initialColumns);
              }
            }
      },
          {
            label: "Form List",
            link: routes.LEADCAPTUREFORM,
            handleClick: () => {
              setIsShowCreateLeadSection(false);
              setViewOpenForm?.(false);
              if(setColumns){
                setColumns(initialColumns);
              }
            },
          },
          {
            label: formName,
            link: "#",
            handleClick: () => {
              setIsPreview(false);
              setIsCreateLeadDragDrop(true);
              setBreadcrumb();
            },
          },
          { label: "Edit", link: "#", handleClick: () => {} },
        ];
  }else if (viewType === "new preview") {
    return [
      {
            label: "Lead Capture",
            link: "/home/lead-management/lead-capture",
            handleClick: () => {
              setIsShowCreateLeadSection(false);
              setViewOpenForm?.(false);
              if(setColumns){
                setColumns(initialColumns);
              }
            }
      },
          {
            label: "Form List",
            link: routes.LEADCAPTUREFORM,
            handleClick: () => {
              setIsShowCreateLeadSection(false);
              setViewOpenForm?.(false);
              if(setColumns){
                setColumns(initialColumns);
              }
            },
          },
          {
            label: "Custom Lead Form",
            link: "#",
            handleClick: () => {
              setIsPreview(false);
              setIsCreateLeadDragDrop(true);
              setBreadcrumb();
            },
          },
          { label: "Preview", link: "#", handleClick: () => {} },
        ];
  }else if(viewType === "view"){
        return [
          {
            label: "Lead Capture",
            link: "/home/lead-management/lead-capture",
            handleClick: () => {
              setIsShowCreateLeadSection(false);
              setViewOpenForm?.(false);
              if(setColumns){
                setColumns(initialColumns);
              }
            }
          },
          {
            label: "Form List",
            link: routes.LEADCAPTUREFORM,
            handleClick: () => {
              setIsShowCreateLeadSection(false);
              setViewOpenForm?.(false);
              if(setColumns){
                setColumns(initialColumns);
              }
            },
          },
          {
            label: formName,
            link: "",
          },
          { label: "Preview", link: "#", handleClick: () => {} },
    ];
  }
};

